module.exports = __webpack_public_path__ + "static/avatar-alexander-9d880ebee9bc9b31b9085e60fd40c1a7.jpg";